import { useSpeakingStarterText } from "./misc/useSpeakingStarters";
import { QuestBubble } from "./misc/QuestBubble";
import React from "react";
import { useOpenAssistant } from "../../../../components/assistant/assistantHooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@duocards/pro-regular-svg-icons";
import styled from "styled-components/macro";
import { useTheme, Zoom } from "@mui/material";

const BubbleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const MicIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.duo.color.primary};
  font-size: 18px;
`;

export function LetsSpeakBubble() {
  const openAssistant = useOpenAssistant();
  const { starter } = useSpeakingStarterText({ forceUpdateStarter: true });

  const theme = useTheme();

  const handleClick = () => {
    if (!starter) return;

    openAssistant({
      autoApplyMode: "speaking",
      openAnimation: Zoom
    });
  };

  if (!starter) return null;

  return (
    <QuestBubble background={theme.duo.color.white}>
      <BubbleContent onClick={handleClick}>
        <span>{starter}</span>
        <MicIcon icon={faMicrophone} />
      </BubbleContent>
    </QuestBubble>
  );
}
